import {PIXI} from '@colonist/pixi'
import {isCloseTo} from '../ui_utils/Utils'
import {StorageWrapper} from '../StorageWrapper'
import {UIGameManager} from '../ui_game/UIGameManager'
import {uiGameManager} from '../../../shared/scripts/EntryShared'
import {UIGameAnimation} from '../ui_game/UIGameEventController'
import {Point} from '@colonist/game-mechanic-validators'
import {TurnState} from '@colonist/game-states'

/** @deprecated use GoToPointAnimation instead. Use GoToPointFadeAnimation if you want a fade-in and fade-out animation*/
export class ViewAnimationController implements UIGameAnimation {
    private readonly uiGameManager: UIGameManager
    private velocity: number
    private destination?: Point
    protected readonly view: PIXI.Container

    private _animationCompleteCallBack: () => void = () => undefined
    set animationCompleteCallBack(value: () => void) {
        this._animationCompleteCallBack = value
    }

    get animationCompleteCallBack(): () => void {
        return this._animationCompleteCallBack
    }

    constructor(view: PIXI.Container) {
        this.uiGameManager = uiGameManager
        this.view = view
    }

    onGameTick(deltaTime: number) {
        this.animate(deltaTime)
    }

    /** @deprecated If you see this, refactor the animation to use GoToPointAnimation instead` */
    animateTo(destination: Point, speed: number = 1) {
        this.setVelocity(speed)
        this.destination = destination

        if(!StorageWrapper.getAnimation()) {
            this.endAnimation()
            return
        }
        this.startAnimation()
    }

    private startAnimation() {
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.GameEnd) this.endAnimation()
        this.uiGameManager.eventController.registerUIGameAnimation(this)
    }

    private animate(deltaTime: number) {
        if(this.destination == undefined) return

        const isCloseToCompleteX = isCloseTo(this.view.x, this.destination.x, this.velocity * deltaTime)
        const isCloseToCompleteY = isCloseTo(this.view.y, this.destination.y, this.velocity * deltaTime)

        const distanceX = this.destination.x - this.view.x
        const distanceY = this.destination.y - this.view.y

        const diagonalDistance = Math.sqrt(distanceX * distanceX + distanceY * distanceY)
        if((isCloseToCompleteX && isCloseToCompleteY) || diagonalDistance < 0.1) {
            this.endAnimation()
            return
        }

        const normalizedDirectionVectorX = distanceX / diagonalDistance
        const normalizedDirectionVectorY = distanceY / diagonalDistance

        const currentFrameMovementAmount = Math.min(this.velocity * deltaTime, diagonalDistance)

        this.view.x += normalizedDirectionVectorX * currentFrameMovementAmount
        this.view.y += normalizedDirectionVectorY * currentFrameMovementAmount
    }

    private endAnimation() {
        if(this.destination == undefined) return

        this.view.x = this.destination.x
        this.view.y = this.destination.y

        this.onAnimationEnd()
    }

    private onAnimationEnd() {
        this.uiGameManager.eventController.unregisterUIGameAnimation(this)
        this.animationCompleteCallBack()
    }

    private setVelocity(speed: number) {
        const {appW, appH} = this.uiGameManager.canvasController
        const appSize = Math.max(appW, appH)
        this.velocity = speed * appSize / 125
    }
}
